module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAADCAYAAACj1j4PAAAAFklEQVQImWO0zfn9n4EMwESOJoo0AgC9mgKp4LXgdgAAAABJRU5ErkJggg=="